const signInFields = [
  {
    labelText: "Username",
    labelFor: "username",
    id: "username",
    name: "username",
    type: "text",
    autoComplete: "username",
    isRequired: true,
    placeholder: "Username",
  },
  {
    labelText: "Password",
    labelFor: "password",
    id: "password",
    name: "password",
    type: "password",
    autoComplete: "current-password",
    isRequired: true,
    placeholder: "Password",
  },
];

const signUpFields = [
  {
    labelText: "First name",
    labelFor: "firstname",
    id: "firstname",
    name: "firstname",
    type: "text",
    autoComplete: "firstname",
    isRequired: true,
    placeholder: "Enter your first name",
  },
  {
    labelText: "Last name",
    labelFor: "lastname",
    id: "lastname",
    name: "lastname",
    type: "text",
    autoComplete: "lastname",
    isRequired: true,
    placeholder: "Enter your last name",
  },
  {
    labelText: "Email",
    labelFor: "email",
    id: "email",
    name: "email",
    type: "email",
    autoComplete: "email",
    isRequired: true,
    placeholder: "Enter your email",
  },
  {
    labelText: "Username",
    labelFor: "username",
    id: "username",
    name: "username",
    type: "text",
    autoComplete: "username",
    isRequired: true,
    placeholder: "Choose a username",
  },
  {
    labelText: "Password",
    labelFor: "password",
    id: "password",
    name: "password",
    type: "password",
    autoComplete: "password",
    isRequired: true,
    placeholder: "Enter your password",
  },
  {
    labelText: "Confirm password",
    labelFor: "confirm",
    id: "confirm",
    name: "confirm",
    type: "password",
    autoComplete: "confirm",
    isRequired: true,
    placeholder: "Confirm your password",
  }
];

export { signInFields, signUpFields };

